import React from 'react'
import { OpenLinkIcon } from '../../base'
import { useNavigate } from 'react-router-dom'

const AddressCard = React.memo(({address, index, showedit = true}) => {
    const navigate = useNavigate()

    return (
    <>
        <div className='addressCard'>
            <div className='h6'>Address-{index}</div>
           <div className='h6 truncate-1'>{address.full_name} ( {address.phone_number} ) </div>
           <div className='h6 truncate-1'>{address.house_no_building_name}, {address.area}</div>
           <div className='h6 truncate-1'>{address.city}</div>
          {showedit && <span onClick={()=>navigate(`/user/address/${address.id}/details/`)}><OpenLinkIcon/></span>}
       </div>
    </>
  )
})

export default AddressCard